import api from './http'

/* *****메인 FRONT API***** */

// 배너리스트
const getBannerList = (lang = null) => {
  return api.getPromise('GET', '/api/banner', lang) // TODO: lang받는 방식 확인
}

// 카드리스트
const getCardList = (lang = null) => {
  return api.getPromise('GET', '/api/card', lang) // TODO: lang받는 방식 확인
}

export default {
  getBannerList,
  getCardList,
}
